import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, MenuController} from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Http,Headers,RequestOptions} from '@angular/http';
import { LoadingProvider } from '../../providers/loading';

import { Settings } from '../../settings';

import { LoginPage } from '../login/login';
import { MagazinePage } from '../magazine/magazine';
/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  step: number = 0;
  qrCode: string;

  password: string;
  repassword: string;
  email: string;
  requiredForm: FormGroup;

  gender: number;
  birthday: string;
  phonenumber: string = '';
  mobile: string = '';

  checkPrivacyPolicy: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, public http: Http, public loadingProvider: LoadingProvider, public modalCtrl: ModalController, public menuCtrl: MenuController) {

    this.qrCode = this.navParams.get('qr');

    this.requiredForm = this.formBuilder.group({
        email: ['', Validators.compose([Validators.maxLength(70), Validators.pattern('^[a-zA-Z0-9. _]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z ]{2,4}$')])],
        password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        repassword: ['', Validators.required]
    }, {validator: this.matchingPasswords('password', 'repassword')});

    //this.step = 1;

  }


  ionViewDidEnter() {
    // the root left menu should be disabled on this page
    this.menuCtrl.enable(false, 'main-menu');
  }


  ionViewWillLeave() {
    // enable the root left menu when leaving this page
    this.menuCtrl.enable(true, 'main-menu');
  }

  ionViewDidLoad() {
      this.step = 1; //dont works in constructor. It's magic
  }

  matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
      return (group: FormGroup) => {
          let passwordInput = group.controls[passwordKey];
          let passwordConfirmationInput = group.controls[passwordConfirmationKey];
          if (passwordInput.value !== passwordConfirmationInput.value) {
              return passwordConfirmationInput.setErrors({notEquivalent: true})
          }
      }
  }

  openPolicyRead() {
    this.navCtrl.push(MagazinePage, {page: Settings.privacyPolicyPage});
  }

  onPrivacyPolicyRead() {
    this.step = 2;
  }

  onRequiredSubmit() {
    this.step = 3;
  }

  onOptionalSubmit() {
    this.sendRequest();
  }

  sendRequest() {

    this.loadingProvider.show();

    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    let options = new RequestOptions({ headers: headers });
    let username = '';
    if(this.email && this.email.length  > 0) {
      username = this.email.replace(/\s/g, '');
    }

    let password = this.password;

    this.http.post(Settings.teamAppApiUrl +'/structure/register.php', 'api_token='+Settings.teamAppApiToken+'&user_mail='+encodeURI(username.toLowerCase())+'&user_password='+encodeURI(password)+'&user_gender='+this.gender+'&user_birthday='+this.birthday+'&user_phone='+this.phonenumber+'&user_mobile='+this.mobile+'&user_device_id=null&user_qr='+this.qrCode, options).subscribe((response) => {

      this.loadingProvider.hide();
      let result = response.json();

      if(result && result.code == 1) {
          this.step = 4;
      } else if(result && result.code == 2) {

      }

    });

  }

  showLogin() {
    this.navCtrl.setRoot(LoginPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts